import { AuthPayload } from "@/interfaces/ui.interface"

export default {
  setDashboard(state: any, payload: AuthPayload) {
    state.responseDashboad = payload
  },
}